import { Pipe, PipeTransform } from '@angular/core';

const PAYMENT_METHOD_LABELS: { [paymentMethod: string]: string } = {
  INVOICE: 'Invoice',
  COLLECTIVE_INVOICE: 'Collective invoice',
  PAY_IN_ADVANCE: 'Pay in advance',
  ZAVER_A2A: 'Bank transfer',
  FINAPI_A2A: 'Bank transfer',
  INSTANT_DEBIT: 'Instant debit',
  INSTANT_DEBIT_INVOICE: 'Instant debit invoice',
  CREDIT: 'Installments',
  CREDIT_DIRECT_DEBIT: 'Installments (direct debit)',
  CREDIT_STATIC_AMOUNT: 'Installments (fixed amount)',
  SWISH_EXTERNAL: 'Swish',
  VIPPS_EXTERNAL: 'Vipps',
  ACCOUNT_RECEIVABLE_FINANCING_INVOICE_CONVERTIBLE: 'Pay later',
  ACCOUNT_RECEIVABLE_FINANCING_ANNUITY: 'Installments',
};

export function formatPaymentMethod(paymentMethod: string): string {
  if (!paymentMethod) {
    return '';
  }
  const label = PAYMENT_METHOD_LABELS[paymentMethod];
  if (label) {
    return label;
  }
  // Fallback for unknown methods, e.g. 'NEW_METHOD' -> 'New method'
  const words = paymentMethod.toLowerCase().replace(/_/g, ' ');
  return words.charAt(0).toUpperCase() + words.slice(1);
}

@Pipe({
  name: 'PaymentMethodFormatter',
})
export class PaymentMethodFormatter implements PipeTransform {
  transform(value: string): string {
    return formatPaymentMethod(value);
  }
}
